<script lang="ts" setup>
defineProps({
  type: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div v-if="type === 'success'">
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.6">
        <path
          d="M25.6533 14.6134C25.1333 14.0934 24.2933 14.0934 23.7733 14.6134L17.4 20.9867L15.1733 18.7601C14.6533 18.2401 13.8133 18.2401 13.2933 18.7601C12.7733 19.2801 12.7733 20.1201 13.2933 20.6401L16.4667 23.8134C16.5333 23.8801 16.6 23.9334 16.68 23.9867C17.2 24.3334 17.9067 24.2667 18.36 23.8134L25.6667 16.5067C26.1867 15.9867 26.1867 15.1467 25.6667 14.6267L25.6533 14.6134Z"
          fill="black" />
      </g>
      <path
        opacity="0.6"
        d="M4.04552 10.366L19 1.73205L33.9545 10.366V27.634L19 36.2679L4.04552 27.634V10.366Z"
        stroke="black"
        stroke-width="3" />
    </svg>
  </div>
  <div v-if="type === 'warn'">
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.6">
        <path
          d="M19.0003 11C19.7337 11 20.3337 11.6 20.3337 12.3333L20.3337 20.3333C20.3337 21.0667 19.7337 21.6667 19.0003 21.6667C18.267 21.6667 17.667 21.0667 17.667 20.3333L17.667 12.3333C17.667 11.6 18.267 11 19.0003 11Z"
          fill="black" />
        <path
          d="M19.0003 24.3334C19.7337 24.3334 20.3337 24.9334 20.3337 25.6667C20.3337 26.4 19.7337 27 19.0003 27C18.267 27 17.667 26.4 17.667 25.6667C17.667 24.9334 18.267 24.3334 19.0003 24.3334Z"
          fill="black" />
      </g>
      <path
        opacity="0.6"
        d="M4.04552 10.366L19 1.73205L33.9545 10.366V27.634L19 36.2679L4.04552 27.634V10.366Z"
        stroke="black"
        stroke-width="3" />
    </svg>
  </div>
  <div v-if="type === 'info'">
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.6">
        <path
          d="M19.0003 16.3334C19.7337 16.3334 20.3337 16.9334 20.3337 17.6667V25.6667C20.3337 26.4 19.7337 27 19.0003 27C18.267 27 17.667 26.4 17.667 25.6667V17.6667C17.667 16.9334 18.267 16.3334 19.0003 16.3334Z"
          fill="black" />
        <path
          d="M19.167 17.6667C19.167 18.4 19.7338 19 19.0004 19L17.8333 19C17.0999 19 16.5 18.4 16.5 17.6667C16.5 16.9334 17.0999 16.3334 17.8333 16.3334L19.0004 16.3334C19.7338 16.3334 19.167 16.9334 19.167 17.6667Z"
          fill="black" />
        <path
          d="M21.667 26.3333C21.667 27.0667 21.067 27.6667 20.3337 27.6667L17.6771 27.6667C16.9437 27.6667 16.3437 27.0667 16.3437 26.3333C16.3437 25.6 16.9437 25 17.6771 25L20.3337 25C21.067 25 21.667 25.6 21.667 26.3333Z"
          fill="black" />
        <path
          d="M19 10C20.1 10 21 10.9 21 12C21 13.1 20.1 14 19 14C17.9 14 17 13.1 17 12C17 10.9 17.9 10 19 10Z"
          fill="black" />
      </g>
      <path
        opacity="0.6"
        d="M4.04552 10.366L19 1.73205L33.9545 10.366V27.634L19 36.2679L4.04552 27.634V10.366Z"
        stroke="black"
        stroke-width="3" />
    </svg>
  </div>
  <div v-if="type === 'error'">
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.6"
        d="M24.6537 15.2267C25.1737 14.7067 25.1737 13.8667 24.6537 13.3467C24.1337 12.8267 23.2937 12.8267 22.7737 13.3467L19.0004 17.12L15.227 13.3467C14.707 12.8267 13.867 12.8267 13.347 13.3467C12.827 13.8667 12.827 14.7067 13.347 15.2267L17.1204 19L13.347 22.7733C12.827 23.2933 12.827 24.1333 13.347 24.6533C13.867 25.1733 14.707 25.1733 15.227 24.6533L19.0004 20.88L22.7737 24.6533C23.2937 25.1733 24.1337 25.1733 24.6537 24.6533C25.1737 24.1333 25.1737 23.2933 24.6537 22.7733L20.8804 19L24.6537 15.2267Z"
        fill="black" />
      <path
        opacity="0.6"
        d="M4.04552 10.366L19 1.73205L33.9545 10.366V27.634L19 36.2679L4.04552 27.634V10.366Z"
        stroke="black"
        stroke-width="3" />
    </svg>
  </div>
</template>
